// CLOUDWEB-21024: контракт debug-команд page -> SW. Отдельно от omicronConfigBridge, потому
// что это не доставка конфига, а ручные действия из консоли.
//
// Почему команда живёт в воркере, а вызывается со страницы: `showNotification` и весь путь
// показа доступны только в SW, а консоль воркера доступна не везде — в Safari его вообще не
// видно в инспекторе, есть только DevTools страницы.

/** Page -> SW: прогнать обработку пуша с переданным payload. */
export const SW_TEST_PUSH_TYPE = 'CLOUD_SW_TEST_PUSH';

export interface SwTestPushMessage {
    type: typeof SW_TEST_PUSH_TYPE;
    /** Payload в том виде, в каком его отдаёт `unwrapPayload` (плоские поля пуша). */
    payload: Record<string, unknown>;
}

/** SW -> Page: результат прогона. Приходит в `MessageChannel`-порт запроса. */
export interface SwTestPushReply {
    ok: boolean;
    error?: string;
}
